import {
  CheckCircle2, CreditCard, Truck, FileText, PlayCircle, Archive,
  PackageX, FileCheck2, Clock3, AlertTriangle,
} from "lucide-react";

export const STATE_ICONS = {
  RG: Clock3, AP: CreditCard, PA: CheckCircle2, PR: FileCheck2,
  AF: Truck, FE: FileText, EV: Truck, DO: PlayCircle,
  EC: Archive, CC: PackageX, CP: AlertTriangle, PC: PackageX,
};

export const STATE_COLOR = {
  RG: "bg-slate-100 text-slate-700",
  AP: "bg-amber-100 text-amber-800 border-amber-200",
  PA: "bg-emerald-100 text-emerald-800 border-emerald-200",
  PR: "bg-emerald-100 text-emerald-800 border-emerald-200",
  AF: "bg-blue-100 text-blue-800 border-blue-200",
  FE: "bg-indigo-100 text-indigo-800 border-indigo-200",
  EV: "bg-violet-100 text-violet-800 border-violet-200",
  DO: "bg-teal-100 text-teal-800 border-teal-200",
  EC: "bg-slate-200 text-slate-700 border-slate-300",
  CC: "bg-rose-100 text-rose-700 border-rose-200",
  CP: "bg-rose-50 text-rose-600 border-rose-100",
  PC: "bg-rose-100 text-rose-700 border-rose-200",
};

export const EUR = (v) => (Number(v) || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });
